import { EBuildingElevatorType } from '../../../../json_query';
import { IBuildingElevatorTypesTag } from '../../../state/tags/definitions/building_elevator';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const buildingElevatorMap = {
  [EBuildingElevatorType.Service]: 'Грузовой лифт',
  [EBuildingElevatorType.Passenger]: 'Пассажирский лифт',
  [EBuildingElevatorType.Telpher]: 'Тельфер',
};

export const BuildingElevatorTypesTagItem = getMultiSelectionParamTagItem<
  EBuildingElevatorType,
  IBuildingElevatorTypesTag
>(buildingElevatorMap);
